import { render, staticRenderFns } from "./MenuPreview.vue?vue&type=template&id=07d98b1c&scoped=true"
import script from "./MenuPreview.vue?vue&type=script&lang=js"
export * from "./MenuPreview.vue?vue&type=script&lang=js"
import style0 from "./MenuPreview.vue?vue&type=style&index=0&id=07d98b1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d98b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d98b1c')) {
      api.createRecord('07d98b1c', component.options)
    } else {
      api.reload('07d98b1c', component.options)
    }
    module.hot.accept("./MenuPreview.vue?vue&type=template&id=07d98b1c&scoped=true", function () {
      api.rerender('07d98b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Inventory/previews/MenuPreview.vue"
export default component.exports